//import Swal from "sweetalert2";
//import Vue from "vue";
import {
    getBestStockListReport,
    getBorrowerCurrentListReport,
    getChequeSumReport,
    getCompanyTotalInfoReport,
    getExpenseReport,
    getExpenseTotalReport,
    getGiroAnalysisReport,
    getMonthGiroDistributionReport,
    getPayeeCurrentListReport,
    getPurchaseReport,
    getSaleReport,
    getCurrencySaleReport,
    getSalespersonSalePaymentDetailReport,
    getSalespersonSalePaymentReport,
    getStockDetailReport,
    getTop10CurrentListReport,
    getBillSumReport,
    getCurrentAgingSummarySum,
    getCurrencyPurchaseReport,
} from "@/services/modules/reports/reportService";

/*import {numberConverter} from "../../../helpers";
import {formattedDate} from "@/momentHelper";*/

export const state = {
    errorMessageAll:"",
    stockDetailData:{
        leftAmount: 0
    },
    stockDetailDataLoading: false,
    reportCompanyData:{
        totalErpCustomer: 0,
        totalB2bCustomer: 0,
        totalSupplier: 0,
        totalB2bOrder: 0,
        totalErpOrder: 0,
        totalStock: 0,
        totalStockPrice: 0.0,
        totalCurrentDebit: 0,
        totalCurrentCredit: 0,
        totalCurrentBalance: 0,
        totalB2bSale: 0,
        totalErpSale: 0,
        totalOffer: 0,
        totalOfferSale: 0,
        dollar: 0.0,
        euro: 0.0,
        pound: 0.0
    },
    reportCompanyDataLoading: false,
    salespersonSalePaymentHeaders: [],
    salespersonSalePaymentData: [],
    salespersonSalePaymentDataLoading: false,
    salespersonSalePaymentDataChart: [],
};

export const mutations = {
    setErrorMessageAll(state,data){
      state.errorMessageAll = data;
    },

    setStockDetailData(state, data) {
        state.stockDetailData = data;
    },
    setStockDetailDataLoading(state, data) {
        state.stockDetailDataLoading = data;
    },
    setReportCompanyData(state, data) {
        state.reportCompanyData = data;
    },
    setReportCompanyDataLoading(state, data) {
        state.reportCompanyDataLoading = data;
    },
    setSalespersonSalePaymentHeaders(state, data) {
        state.salespersonSalePaymentHeaders = data;
    },
    setSalespersonSalePaymentData(state, data) {
        state.salespersonSalePaymentData = data;
    },
    setSalespersonSalePaymentDataLoading(state, data) {
        state.salespersonSalePaymentDataLoading = data;
    },
    setSalespersonSalePaymentDataChart(state, data) {
        state.salespersonSalePaymentDataChart = data;
    },

}

export const getters = {
    getCurrencies(state){
        let currencies = {dollar: state.reportCompanyData.dollar, euro: state.reportCompanyData.euro, pound: state.reportCompanyData.pound}
        localStorage.setItem('currencies', JSON.stringify(currencies));
    }
};

export const actions = {
    async fetchCompanyTotalInfoReport(context,{params, body}){
        let result = false;
        context.commit("setReportCompanyDataLoading",true);
        result = await getCompanyTotalInfoReport(params,body);
        context.commit("setReportCompanyDataLoading",false);
        if(!result.data.success)
        {
            result = false;
            context.commit("setReportCompanyData", {
                totalErpCustomer: 0,
                totalB2bCustomer: 0,
                totalSupplier: 0,
                totalB2bOrder: 0,
                totalErpOrder: 0,
                totalStock: 0,
                totalStockPrice: 0.0,
                totalCurrentDebit: 0,
                totalCurrentCredit: 0,
                totalCurrentBalance: 0,
                totalB2bSale: 0,
                totalErpSale: 0,
                totalOffer: 0,
                totalOfferSale: 0,
                dollar: 0.0,
                euro: 0.0,
                pound: 0.0
            });
            return result;
        }
        else
        {
            context.commit("setReportCompanyData",result.data.data);
            return result;
        }
    },
    async fetchStockDetailReport(context,{params, body}){
        let result = false;
        context.commit("setStockDetailDataLoading",true);
        result = await getStockDetailReport(params,body);
        context.commit("setStockDetailDataLoading",false);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            context.commit("setStockDetailData", {
                leftAmount: 0
            });
            return result;
        }
        else
        {
            context.commit("setStockDetailData",result.data.data);
            return result
        }
    },
    async fetchMonthGiroDistributionReport(context,{params, body}){
        let result = false;
        result = await getMonthGiroDistributionReport(params,body);

        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchGiroAnalysisReport(context,{params, body}){
        let result = false;
        result = await getGiroAnalysisReport(params,body);

        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchSaleReport(context,{params, body}){
        let result = false;
        result = await getSaleReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {

            return result
        }
    },

    async fetchCurrencySaleReport(context,{params, body}){
        let result = false;
        result = await getCurrencySaleReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchPurchaseReport(context,{params, body}){
        let result = false;
        result = await getPurchaseReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchCurrencyPurchaseReport(context,{params, body}){
        let result = false;
        result = await getCurrencyPurchaseReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchChequeSumReport(context,{params, body}){
        let result = false;
        result = await getChequeSumReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchBillSumReport(context,{params, body}){
        let result = false;
        result = await getBillSumReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchBorrowerCurrentList(context,{params, body}){
        let result = false;
        result = await getBorrowerCurrentListReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchTop10CurrentList(context,{params, body}){
        let result = false;
        result = await getTop10CurrentListReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchPayeeCurrentList(context,{params, body}){
        let result = false;
        result = await getPayeeCurrentListReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },
    async fetchBestStockList(context,{params, body}){
        let result = false;
        result = await getBestStockListReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            return result;
        }
        else
        {
            return result
        }
    },
    async fetchSalesPersonSalePaymentList(context,{params, body}){
        let result = false;
        result = await getSalespersonSalePaymentReport(params,body);
        // context.commit("setSalespersonSalePaymentDataChart",result.data.data);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },

    async fetchExpenseList(context,{params, body}){
        let result = false;
        result = await getExpenseReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);
            return result;
        }
        else
        {
            return result
        }
    },

    async fetchExpenseListTotal(context,{params, body}){
        let result = false;
        result = await getExpenseTotalReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);

            result = false;
            return result;
        }
        else
        {
            return result
        }
    },

    async fetchSalesPersonSalePaymentDetailList(context,{params, body}){
        let result = false;
        result = await getSalespersonSalePaymentDetailReport(params,body);
        if(!result.data.success)
        {
            context.commit("setErrorMessageAll",result.data.message);
            return result;
        }
        else
        {
            return result
        }
    },

    async fetchCurrentAgingSummarySum(context,{params, body}){
        let result = false;
        result = await getCurrentAgingSummarySum(params,body);
        if(!result.data.success)
        {
            result = false;
            return result;
        }
        else
        {
            return result
        }
    },

    prepareCurrencyAmount(context, {data}) {
        // let dynamicReportHeader = `${reportType}Headers`
        // let dynamicReportData = `${reportType}Data`
        let dynamicReportHeader = [];
        let dynamicReportData = [];
        dynamicReportHeader.push({
            key: 'vatExcludedAmount',
            label: "Tutar (TL)",
            sortable: false,
            class: 'text-center pe-4'
        })
        data.map((item) => {
            dynamicReportHeader.push({
                key: item.currencyName,
                label: item.currencySymbol,
                sortable: false,
                class: 'text-center pe-4'
            })
            let keytemp = `${item.currencyName}`
            item[keytemp] = item.vatExcludedAmount;
            delete item.vatExcludedAmount;
            let existingItem = dynamicReportData[0];
            if (existingItem) {
                existingItem[item.currencyName] = item[keytemp];
            } else {
                let newObj = {
                    [item.currencyName]: item[keytemp]
                };
                dynamicReportData.push(newObj);
            }
        })
        return {dynamicReportHeader,dynamicReportData}
    }

};
